import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ResizeDetectionService } from '../../../services/resize-detection.service';
import { PlanOrderDetailModel } from '../../../models/plan/plan-order-detail-model';
import { HomeService } from '../../../services/home/home.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StripeService, StripeCardComponent, injectStripe, StripePaymentElementComponent } from 'ngx-stripe';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { Appearance, PaymentIntent, StripeCardElementOptions, StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { Observable } from 'rxjs';
import { PlanService } from '../../../services/plan/plan.service';
import { NgxGpAutocompleteDirective } from '@angular-magic/ngx-gp-autocomplete';
import { OurShopService } from '../../../services/our-shop/our-shop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JwtTokenService } from '../../../services/auth/jwt-token.service';
import { HttpClient } from '@angular/common/http';
import { AuthDialogService } from 'src/app/nutrigenic/services/auth/auth-dialog.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from '../../../services/analytics/analytics.service';

@Component({
  selector: 'app-order-checkout',
  templateUrl: './order-checkout.component.html',
  styleUrls: ['./order-checkout.component.scss']
})
export class OrderCheckoutComponent {

    mealsList: any[] = [];
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    planOrderDetails: PlanOrderDetailModel = new PlanOrderDetailModel();
    cart:any = [];
    paymentPopUpVisibility: boolean = false;
    showOrderSuccessPopup: boolean = false;
    
    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;
    showMainCheckout: boolean = false;
    showAddOnsCheckout: boolean = false;

    

    currWeek:number = 1;
    deliveryFees:number = 3.95;
    singleDeliveryPrice: number = 3.95;
    discount:number = 0;
    weeklyDeliveriesCount: number = 1;
    
    promo_discount_id:number = 0;
    promo_code:string = '';
    promo_discount_object: any = null;
    free_shipping_type: string = '';

    day:string = "";
    deliveryDate:string = "";
    dates:any = [];
    selectedDate:any;

    suggestions:any = [];
    suggestions_all:any = [];
    full_address: string = '';

    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    appearance: Appearance = { theme: 'stripe' };
    cardOptions: StripeCardElementOptions = {
        //hidePostalCode: true,
        style: {
            base: {
              iconColor: '#666EE8',
              color: '#31325F',
              fontWeight: '300',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSize: '18px',
              '::placeholder': {
                color: '#CFD7E0',
              },
            },
          },
    };

    @ViewChild(StripePaymentElementComponent) paymentElement: StripePaymentElementComponent;
    stripe = injectStripe(environment.stripe_api_key);
    paymentElementOptions: StripePaymentElementOptions = {
        layout: {
          type: 'tabs',
          defaultCollapsed: false
        },
        wallets: {
          applePay: 'auto',
          googlePay: 'auto',
          link: 'never'
        }
    } as any;

    elementsOptions: StripeElementsOptions = {
        locale: 'en',
        //appearance: this.appearance
        appearance: {
          theme: 'flat',
        }
    };

    stripeTest: FormGroup;

    items: MenuItem[];
    activeItem: MenuItem;
    addressSearchType: boolean = false;

    phone_number:string = '';
    phonePrefix: string = '+44';
    phonePrefixes = [
        { label: '+44 (UK)', value: '+44' },
        /*
        { label: '+1 (US)', value: '+1' },
        { label: '+33 (FR)', value: '+33' },
        { label: '+49 (DE)', value: '+49' },
        { label: '+39 (IT)', value: '+39' },
        { label: '+34 (ES)', value: '+34' }
         */
    ];
    address:string = '';
    city:string = '';
    zip:string = '';
    @ViewChild('ngxPlaces') placesRef: NgxGpAutocompleteDirective;
    place:any;
    options:any = {};
    
    

    constructor(
        private route: ActivatedRoute,
        private sizedetection: ResizeDetectionService,
        private homeService: HomeService,
        private ourShopService: OurShopService,
        private router: Router,
        private fb: FormBuilder,
        private stripeService: StripeService,
        private planService: PlanService,
        private spinner: NgxSpinnerService,
        private jwtService: JwtTokenService,
        private authDialogService: AuthDialogService,
        private http: HttpClient,
        private analyticsService: AnalyticsService
    ) {
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe({
            next: data => {
                this.isDesktop = data.isDesktop;
                this.isTablet = data.isTablet;
                this.isMobile = data.isMobile;
                //console.log(this.isTablet);
            },
            error: (error) => {
                this.handleError(error); 
            }
        });
        
    }

    ngOnInit() {

        try{
            
            this.spinner.show();

            if (localStorage.getItem('cookie')) {
                this.cookiePopupVisibility = false;
            } else this.cookiePopupVisibility = true;

            
            this.stripeTest = this.fb.group({
                name: ['', [Validators.required]]
                //address: ['', [Validators.required]],
                //city: ['', [Validators.required]],
                //zip: ['', [Validators.required]]
            });

            
            this.items = [
                { label: 'Delivery', icon: 'pi pi-fw pi-align-left' },
                { label: 'Payment', icon: 'pi pi-fw pi-wallet', disabled: true }
            ];
            this.activeItem = this.items[0];

            

            // Shipping Date
            this.selectedDate = this.getFromLocalStorage('selectedDate');
            this.deliveryDate = this.selectedDate["name"];
            this.cart = this.getFromLocalStorage('cart');
            this.planOrderDetails = this.getFromLocalStorage('orderDetails');
            this.discount = 0;

            let order = localStorage.getItem('order');
            if(order){
                const orderData = JSON.parse(order);
                this.address = orderData.address;
                this.city = orderData.city;
                this.zip = orderData.zip;
                const matchedPrefix = this.phonePrefixes.find(prefix => orderData.phone_number.startsWith(prefix.value));
                this.phone_number = matchedPrefix ? orderData.phone_number.substring(matchedPrefix.value.length) : orderData.phone_number;
                this.phonePrefix = this.phonePrefixes.find(prefix => orderData.phone_number.startsWith(prefix.value))?.value || '+44';
                this.stripeTest.setValue({ name: orderData.fullname })
            }

            if (localStorage.getItem('free_shipping_type')) {
                this.free_shipping_type = localStorage.getItem('free_shipping_type')!;
            }


            if (localStorage.getItem('promo_discount') && localStorage.getItem('promo_discount_id')) {
                let promoDiscount = localStorage.getItem('promo_discount');
                this.discount = promoDiscount ? parseFloat(promoDiscount) : 0;

                let promoDiscountId = localStorage.getItem('promo_discount_id');
                this.promo_discount_id = promoDiscountId ? parseInt(promoDiscountId) : 0;
                
                //console.log(this.discount);
            }
            if (localStorage.getItem('promo_code')) {
                let promoDiscountId = localStorage.getItem('promo_discount_id');
                this.promo_discount_id = promoDiscountId ? parseInt(promoDiscountId) : 0;

                this.promo_code = localStorage.getItem('promo_code') ?? '';

                if(localStorage.getItem('promo_discount_object')){
                    this.promo_discount_object = localStorage.getItem('promo_discount_object');
                    this.promo_discount_object = JSON.parse(this.promo_discount_object);
                    this.discount = parseFloat(this.promo_discount_object.discount.firstWeekDiscount);
                    //console.log(this.discount);
                    if(this.promo_discount_object.free_shipping_type){
                        this.free_shipping_type = this.promo_discount_object.free_shipping_type;
                        
                    }
                }
            }
            
            
            this.getWeeklyDeliveriesCount();
            this.deliveryFees = this.getDeliveryFeesFirstWeek();
            this.spinner.hide();

        } catch(error){
            this.spinner.hide();
        }
                           
    }


    getFromLocalStorage(localStorageProperty: string) {
        let localStorageObject:any = localStorage.getItem(localStorageProperty);
        if (!localStorageObject) {
            let error = {
                error: {
                    message: 'No plan details found'
                }
            }
            this.handleError(error);
            this.router.navigate(['/order-flow']);
        }
        return JSON.parse(localStorageObject);
    }


    

    getPosition(string:string, subString:string, index:number) {
        return string.split(subString, index).join(subString).length;
    }

    
    private createFreshPaymentIntent() {
        this.createPaymentIntent(parseFloat(this.getFirstWeekTotalPrice())).subscribe({
            next: (res: any) => {
                this.elementsOptions.clientSecret = res.body.client_secret as string;
                // Save the PaymentIntent ID to reuse later
                localStorage.setItem('payment_intent_id', res.body.id);
                setTimeout(() => {
                    this.activeItem = this.items[1];
                    this.items[1].disabled = false;
                    this.spinner.hide();
                }, 200);
            },
            error: (error) => {
                this.spinner.hide();
                this.handleError(error.error);
            }
        });
    }


    onActiveItemChange(event:any) {
        if (event.label != 'Payment' || (event.label == 'Payment' && this.address != '' && this.city != '' && this.zip != '' && this.phone_number != '' && this.phone_number.length>=8 && this.stripeTest.valid) )
        this.activeItem = event;
    }

    createToken(): void {
        const name = this.stripeTest.get('name')?.value;
        this.stripeService
          .createToken(this.card.element, { name }).subscribe({
            next:(result) => {
                if (result.token) {
                // Use the token
                //(result.token.id);
                } 
            },
            error: (error) => {
                this.spinner.hide();
                this.handleError(error);
            }
        });
    }

    createPaymentIntent(amount: number): Observable<PaymentIntent> {
        return this.homeService.createPaymentIntent({ amount: amount * 100 });
    }

    next() {
        this.jwtService.getIsLogin().subscribe({
            next: (resp) => {

                if (resp === true) {

                    if (this.address && this.city && this.zip && this.phone_number && this.phone_number.length >= 8 && this.stripeTest.valid) {

                        this.spinner.show();

                        

                        // Step 1: check if we already have a PI saved
                        /*
                        const existingPiId = localStorage.getItem('payment_intent_id');
                        if (existingPiId) {
                            // Step 2: try to update existing PI with new amount
                            this.homeService.updatePaymentIntent({paymentIntentId: existingPiId,  amount: parseFloat(this.getFirstWeekTotalPrice()) * 100})
                                .subscribe({
                                    next: (res: any) => {
                                        // Force re-initialization by clearing first
                                        this.elementsOptions.clientSecret = undefined;
                                        setTimeout(() => {
                                            this.elementsOptions.clientSecret = res.body.client_secret as string;
                                            setTimeout(() => {
                                                this.activeItem = this.items[1];
                                                this.items[1].disabled = false;
                                                this.spinner.hide();
                                            }, 200);
                                        }, 50);
                                    },
                                    error: (error) => {
                                        console.error(error);
                                        // If updating fails (maybe PI expired), create a new one
                                        this.createFreshPaymentIntent();
                                        this.spinner.hide();
                                    }
                                });
                        } else {
                             */
                            // No existing PI → create a new one
                            this.createFreshPaymentIntent();
                            this.spinner.hide();
                       // }
                           

                    } else if (!this.stripeTest.valid) this.handleErrorFields();
                    else if (!this.address || !this.city || !this.zip) this.handleErrorAddress();
                    else if (!this.phone_number) this.handleErrorPhoneNumber();
                    else if (this.phone_number.length < 8 || !/^\d+$/.test(this.phone_number)) this.handleErrorPhoneNumberInvalid();

                } else {
                    this.authDialogService.openLogin();
                }
            },
            error: (error) => {
                this.handleError(error);
            }
        });
    }

    pay(): void {
        const spinnerWithMessage = "spinner-with-message";
        
        if (!this.isValidPaymentForm()) {
            this.handleValidationErrors();
            return;
        }

        this.spinner.show(spinnerWithMessage);
        this.processPayment(spinnerWithMessage);
    }

    private isValidPaymentForm(): boolean {
        return this.stripeTest.valid && (this.address !== '' || this.place !== undefined);
    }

    private handleValidationErrors(): void {
        if (!this.stripeTest.valid) {
            this.handleErrorFields();
        } else if (this.place === undefined) {
            this.handleErrorAddress();
        }
    }

    private processPayment(spinnerWithMessage: string): void {
        try{
            this.homeService.checkPostcode({ zip: this.zip.replace(" ", "") }).subscribe({
                next: () => this.createOrderAndPay(spinnerWithMessage),
                error: (error) => {
                    this.spinner.hide(spinnerWithMessage);
                    this.handleError(error);
                }
            });
        }catch(error){
            this.spinner.hide(spinnerWithMessage);
            this.handleError(error);
        }
    }

    private createOrderAndPay(spinnerWithMessage: string): void {
        try{
        const order = this.buildOrderObject();
        const orderId = localStorage.getItem('order_id') ? Number(localStorage.getItem('order_id')) : null;

        if(!orderId) { // totally new order
            //console.log(order);
            this.homeService.createOrder(order).subscribe({
                next: (res: any) => {
                    localStorage.setItem('order_id', res.body.order.id);
                    localStorage.setItem('order', JSON.stringify(order));
                    this.processStripePayment(res.body.order.id, spinnerWithMessage)
                },
                error: (error) => {
                    this.spinner.hide(spinnerWithMessage);
                    this.handleError(error);
                }
            });
        } else {
            if(localStorage.getItem('order') === JSON.stringify(order)) { // order exists in backend and user didn't change anything front end before paying
                this.processStripePayment(orderId, spinnerWithMessage);
            } else {
                // user already created an order but before paying changed his mind and modified the plan or the meals
                this.homeService.createOrder(order).subscribe({
                    next: (res: any) => {
                        localStorage.setItem('order_id', res.body.order.id);
                        localStorage.setItem('order', JSON.stringify(order));
                        this.processStripePayment(res.body.order.id, spinnerWithMessage)
                    },
                    error: (error) => {
                        this.spinner.hide(spinnerWithMessage);
                        this.handleError(error);
                    }
                });
            }
        }
        }catch(error){
            this.spinner.hide(spinnerWithMessage);
            this.handleError(error);
        }
        
        
    }

    private buildOrderObject(): any {
        const userId = localStorage.getItem('id');
        let allergies = this.planOrderDetails.allergies;
        const order: any = {
            user_id: userId,
            address: this.address,
            city: this.city,
            zip: this.zip,
            phone_number: this.phonePrefix + this.phone_number,
            fullname: this.stripeTest.get('name')?.value,
            promo_discount_id: this.promo_discount_id !== 0 ? this.promo_discount_id : null,
            discount_amount: this.promo_discount_id === 0 ? this.discount : 0,
            delivery_date: this.selectedDate.key,
            total_amount: parseFloat(this.getFullOrderSubTotalPrice()),
            supplements: [],
            ourshop: [],
            allergies: allergies
        };

        this.setOrderTypeAndDetails(order);
        this.setOrderMeals(order);
        
        return order;
    }

    private setOrderTypeAndDetails(order: any): void {
        if (this.planOrderDetails) {
            order.order_type = this.planOrderDetails.type.toLowerCase();
            order.order_num = this.planOrderDetails.dayPerWeek > 3 ? 'flex' : 'singular';
            order.meals_per_day = this.planOrderDetails.mealPerDay || 1;
            order.days_per_week = this.planOrderDetails.dayPerWeek || 1;
            order.weeks = this.planOrderDetails.weeks || 1;
            order.shipment_amount = this.getDefaultTotalDeliveryFees(order.weeks);
            
            if (this.planOrderDetails.type.toLowerCase() === 'expert') {
                order.expert_id = localStorage.getItem('expert');
            }
        } else {
            order.order_type = 'ourshop';
            order.order_num = 'singular';
            order.meals_per_day = 1;
            order.days_per_week = 1;
            order.weeks = 1;
            order.shipment_amount = this.getDeliveryFeesFirstWeek();
        }
    }

    private setOrderMeals(order: any): void {
        order.meals = [];
        let week = 0;
        
        this.cart.forEach((weekEl: any) => {
            week++;
            weekEl.forEach((meal: any) => {
                meal.week = week;
                const newMeal = this.createMealObject(meal);
                order.meals.push(newMeal);
            });
        });
    }

    private createMealObject(meal: any): any {
        const newMeal: { [key: string]: any } = {
            id: meal.id,
            week: meal.week,
            count: meal.count,
            type: meal.type,
            batch_protein_id: meal.batch_protein_id,
            batch_carb_id: meal.batch_carb_id,
            batch_veg_id: meal.batch_veg_id,
            protein_amount_id: meal.protein_amount?.id,
            carb_amount_id: meal.carb_amount?.id,
            veg_amount_id: meal.veg_amount?.id
        };

        Object.keys(newMeal).forEach(key => {
            if (newMeal[key] === null) {
                delete newMeal[key];
            }
        });

        return newMeal;
    }

    private processStripePayment(orderId: number, spinnerWithMessage: string): void {
        this.stripe.confirmPayment({
            elements: this.paymentElement.elements,
            confirmParams: {
                payment_method_data: {
                    billing_details: { name: this.stripeTest.get('name')?.value }
                }
            },
            redirect: 'if_required'
        }).subscribe({
            next: (result: any) => {
                if (result.error) {
                    if(result.error.code === 'payment_intent_unexpected_state'){
                        localStorage.removeItem('payment_intent_id');
                        this.activeItem = this.items[0];
                        this.items[1].disabled = true;
                        this.spinner.hide(spinnerWithMessage);
                        this.handleErrorStripe(result.error.message + " Please try again");
                    } else{
                        this.handlePaymentError(result.error, orderId, spinnerWithMessage, result.error.payment_intent?.id);
                    }
                } else {
                    this.handlePaymentResult(result, orderId, spinnerWithMessage);
                }
            },
            error: (error) => this.handlePaymentError(error, orderId, spinnerWithMessage)
        });
    }

    private handlePaymentResult(result: any, orderId: number, spinnerWithMessage: string): void {


        const status = result.paymentIntent.status;
        let error: any = [];

        switch (status) {
            case 'succeeded':
                const paymentData = {
                    payment_method: 'Card',
                    external_order_id: result.paymentIntent.id,
                    status: 'paid'
                };

                this.homeService.createOrderPay(orderId, paymentData).subscribe({
                    next: () => { this.trackPurchase(result.paymentIntent.id); this.handleSuccessfulPayment(spinnerWithMessage);},
                    error: (error) => {
                        this.spinner.hide(spinnerWithMessage);
                        this.handleError(error);
                    }
                });

                break;
            case 'requires_payment_method':
                // Payment failed (card declined / auth failed)
                // Show error message and ask customer to provide a new payment method
                error.message = result.paymentIntent.last_payment_error?.message || 
                         'Payment failed. Please provide a new payment method.';
                this.handlePaymentError(error, orderId, spinnerWithMessage, result.paymentIntent.id);
                break;

            case 'canceled':
                // Payment canceled → show failure message
                error.message = result.paymentIntent.last_payment_error?.message || 
                         'Payment failed. Please provide a new payment method.';
                this.handlePaymentError(error, orderId, spinnerWithMessage, result.paymentIntent.id);
                break;
        }
    
    }

    private handlePaymentError(error: any, orderId: number, spinnerWithMessage: string, paymentIntentId: string = ''): void {
        
        const paymentData: any = {
            payment_method: 'Card',
            status: 'failed',
            notes: error.message
        };

        if (paymentIntentId) {
            paymentData.external_order_id = paymentIntentId;
        }

        this.homeService.createOrderPay(orderId, paymentData).subscribe({
            next: () => { 
                this.spinner.hide(spinnerWithMessage);
                this.handleErrorStripe(error.message);
            },
            error: (err) => {
                this.spinner.hide(spinnerWithMessage);
                this.handleErrorStripe(error.message);
                this.handleError(err);
            }
        });  
    }

    private handleSuccessfulPayment(spinnerWithMessage: string): void {
        this.paymentPopUpVisibility = false;
        this.clearLocalStorage();
        this.ourShopService.clearCart();
        //this.handleSuccessResponse();
        this.spinner.hide(spinnerWithMessage);
        this.showOrderSuccessPopup = true;
    }

    private clearLocalStorage(): void {
        const itemsToRemove = [
            'planOrderDetails', 'orderDetails', 'cart', 'cartNum', 'addons', 'promo_code',
            'selectedDate', 'promo_discount', 'promo_discount_id',
            'promo_discount_object', 'payment_intent_id',
            'order', 'order_id', 'free_shipping_type', 'allergies'
        ];
        
        itemsToRemove.forEach(item => localStorage.removeItem(item));
    }

    trackPurchase(transaction_id: string) {
        let email = localStorage.getItem('email');
        let customer_id = localStorage.getItem('customer_id');
        const meal_plans:any = [{id:1, name:"Flexi", value:"Flexi"}, {id:2, name:"Commit", value:"Commit"}, {id:3, name:"Custom", value:"Expert"}];
        let type = meal_plans.filter((x:any)=>x.value==this.planOrderDetails.type)[0].id;
        this.analyticsService.trackEvent('purchase', {
            ecommerce: {
                transaction_id: transaction_id,
                value: parseFloat(this.getFirstWeekTotalPrice()),
                shipping: this.getDeliveryFeesFirstWeek(),
                discount: parseFloat(this.discountVisual()),
                coupon: this.promo_code,
                customer_info: {
                    email: email,                                  // Dynamic: Customer's email
                    phone: this.phone_number,                      // Dynamic: Customer's phone number
                    new_customer: customer_id!='' ? false : true   // Dynamic: Boolean for whether the customer is new (true/false)
                },
                items: [{
                    item_id: type,
                    item_name: meal_plans.filter((x:any)=>x.id==type)[0].name,
                    price: parseFloat(this.getFirstWeekTotalPrice()),
                    quantity: 1
                }],
            },
        });
    }

    handleSuccessResponse(): void {
        Notify.success('Order Created', {
            position: 'right-top',
            timeout: 3000
        });
    }

    handleError(error: any): void {
        console.error('Checkout error:', error);
        if(error.error && error.error.type && error.error.type === 'validation'){
            let errors = error.error.message;
            Object.entries(errors).forEach(([key, value]) => {
                console.log(key, value);
                error = (value as string[])[0];
                Notify.failure(error, {
                    position: 'right-top',
                    timeout: 3000
                });
                if(key === 'old_meals_specified'){
                    localStorage.removeItem('cart');
                    this.router.navigate(['/order-flow']);
                }
            });
        } else {
            error = error.message ?? 'Internal error - Could not complete the operation';
                Notify.failure(error, {
                position: 'right-top',
                timeout: 3000
            });
        }
    }
    
    handleErrorZip(): void {
        Notify.failure('Area not covered by shipping', {
            position: 'right-top',
            timeout: 3000
        });
    }

    handleErrorFields(): void {
        Notify.failure('Insert all required fields', {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorAddress(): void {
        Notify.failure('Invalid address', {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorPhoneNumber(): void {
        Notify.failure('Phone number required', {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorPhoneNumberInvalid(): void {
        Notify.failure('Invalid phone number', {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorStripe(error: any): void {
        Notify.failure(error, {
            position: 'right-top',
            timeout: 3000
        });
    }

    getWeeklyDeliveriesCount() {
        this.planService.getWeeklyDeliveriesCount(this.planOrderDetails.dayPerWeek, this.planOrderDetails.mealPerDay).subscribe(
            (weeklyDeliveriesCount) => this.weeklyDeliveriesCount = weeklyDeliveriesCount
        );
    }

    getDefaultTotalDeliveryFees(orderWeeks: number) {
        if(this.free_shipping_type) {
            if(this.free_shipping_type === 'entire_order') {
                return 0;
            } else if(this.free_shipping_type === 'first_week') {
                return (this.weeklyDeliveriesCount * this.singleDeliveryPrice) * (orderWeeks - 1);
            }
        }
        return this.weeklyDeliveriesCount * this.singleDeliveryPrice * orderWeeks;
    }

    getDeliveryFeesFirstWeek() {
        if(this.free_shipping_type) {
            return 0;
        }
        return this.weeklyDeliveriesCount * this.singleDeliveryPrice;
    }

    
    getWeekSubTotalPrice() {
        let total = 0;
        if (this.cart.length > 0) {
            this.cart[0].forEach((meal:any) => {
                if(meal.type !== 'addon') {
                    total += meal.price * meal.count;
                }
            });
        }
        
        return Number(total).toFixed(2);
    }

    getMealsFromCart() {
        if(this.cart && this.cart.length > 0) {
            return this.cart[0].filter((item: any) => item.type !== 'addon');
        }
        return [];
    }

    getAddonsFromCart() {
        if(this.cart && this.cart.length > 0) {
            return this.cart[0].filter((item: any) => item.type === 'addon');
        }
        return [];
    }

    countTotalAddOns() {
        let total = 0;
        this.getAddonsFromCart().forEach((addon: any) => {
            total += addon.count;
        });
        return total;
    }

    getAddonsSubTotalPrice() {
        let total = 0;
        this.getAddonsFromCart().forEach((addon: any) => {
            total += addon.price * addon.count;
        });
        return Number(total).toFixed(2);
    }

    getWeekDefaultTotalPrice() {
        let total = +this.getWeekSubTotalPrice();
        total =  total + this.weeklyDeliveriesCount * this.singleDeliveryPrice;
        return Number(total).toFixed(2);
    }

    getFullOrderSubTotalPrice() {
        let total = 0;
        if (this.cart.length > 0){
            this.cart.forEach((all:any) => {
                all.forEach((added:any) => {
                    if (added.isAdded == true){
                        total += added.price * added.count;
                    }
                    
                });
            });
        }
        return Number(total).toFixed(2);
    }

    getFullOrderTotalPrice() {
        let total = +this.getFullOrderSubTotalPrice();
        total = total + this.deliveryFees - this.getDiscount();
        return Number(total).toFixed(2);
    }
    
    getFirstWeekTotalPrice() {
        let total = +this.getWeekSubTotalPrice();
        total =  total + this.getDeliveryFeesFirstWeek() - (+this.getDiscountFirst());
        return Number(total).toFixed(2);
    }

    getDiscount() {
        let total = +this.getFullOrderSubTotalPrice();
        return total * this.discount / 100;
    }

    getDiscountFirst() {
        let total = 0;
        if (this.cart.length > 0){
            this.cart[0].forEach((all:any) => {
                if (all.isAdded == true){
                    total += all.price * all.count;
                } 
            });
        }
        
        return Number(total * this.discount / 100).toFixed(2);
    }

    getDiscountedMealPrice() {
        return Number(this.cart[0][0].price - (this.cart[0][0].price * this.discount / 100)).toFixed(2);
    }
    
    discountVisual() {
        return this.getDiscountFirst();
    }

    previousWeek() {
        if (this.currWeek != 1){
            this.currWeek--;
        }  
    }

    nextWeek() {
        if (this.currWeek<this.planOrderDetails.weeks){
            this.currWeek++;
        }
    }


    formatDate(date: Date, separator = "-") {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Two-digit month
        const day = String(date.getDate()).padStart(2, '0'); // Two-digit day

        return `${year}${separator}${month}${separator}${day}`;
    }

    formatDateSlash(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
        const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits

        return `${year}/${month}/${day}`;
    }
    

    goToOrderFlow() {
        this.router.navigate(["order-flow"]);
    }

    goToHome() {
        this.router.navigate(["home"]);
    }

    goToOrderOrderSummary(){
        this.router.navigate(["order-summary"]);
    }

    validatePhoneNumber(event: any) {
        const input = event.target;
        const value = input.value;
        let numbersOnly = value.replace(/\D/g, '');
        
        // Prevent numbers starting with 0
        if (numbersOnly.startsWith('0')) {
            numbersOnly = numbersOnly.substring(1);
        }
        
        input.value = numbersOnly;
        this.phone_number = numbersOnly;
    }

    acceptCookie() {
        localStorage.setItem('cookie', "1");
        this.cookiePopupVisibility = false;
    }

    customizeCookie() {
        this.cookiePopupVisibility = false;
        this.customCookiePopupVisibility = true;
    }

    acceptCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility= false;
    }

    customizeCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility = false;
    }

    rejectCookieOpen() {
        this.customCookiePopupVisibility = false;
    }

    onAddressSelected(address: any) {
        this.address = address.address;
        this.city = address.city;
        this.zip = address.zip;
    }
}
